<script>
	import MapStore from '../../Map/Store';
	import AuthStore from '../../Auth/Store';
	import LngLatFormat from '../../Enums/LngLatFormat';
	import StringHelper from '../../Helpers/StringHelper';
	import "./CoordinatePane.scss"

	let lng;
	let lat;
	let user = AuthStore.session.user;
	let lngLat = MapStore.cursor;
	$: {
		lng = $lngLat.lng;
		lat = $lngLat.lat;

		// console.log("$user.lngLatFormat", $user.lngLatFormat);
		if ($user.lngLatFormat === LngLatFormat.DMS) {
			lng = StringHelper.formatDecimalToDMS(lng);
			lat = StringHelper.formatDecimalToDMS(lat, false);
		}
	}

</script>

<div class="pane coords">
	<p>Longitude: {lng}</p>
	<p>Latitude: {lat}</p>
</div>
